import { render, staticRenderFns } from "./SchoolImages.vue?vue&type=template&id=02ecd774&scoped=true&"
import script from "./SchoolImages.vue?vue&type=script&lang=js&"
export * from "./SchoolImages.vue?vue&type=script&lang=js&"
import style0 from "./SchoolImages.vue?vue&type=style&index=0&id=02ecd774&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ecd774",
  null
  
)

export default component.exports